import { Route, Routes, useLocation } from "react-router-dom"
import Layout from "./components/Layout"
import Home from "./pages/Home"
import Checkout from "./pages/Checkout"
import Cursor from "./components/Cursor"
import { AnimatePresence } from "framer-motion"

import "./General.css"
import "./App.css"
import "./Pages.css"
import "./Scroll.css"
import Product from "./pages/Product"

function App() {
  const location = useLocation()

  return (
    <>
      <Cursor />
      <AnimatePresence mode="wait" initial={false}>
        <Routes key={location.pathname} location={location}>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/product/:productId" element={<Product />} />
          </Route>
        </Routes>
      </AnimatePresence>
    </>
  )
}

export default App
